import { getUser } from "../../auth";
import DeleteProductButton from "../components/DeleteProductButton";

const URL = process.env.REACT_APP_API_URL;

export default function DeleteProduct({ selectedProducts, onDelete }) {
  const user = getUser();

  const handleDelete = () => {
    Promise.all(
      selectedProducts.map((productId) => 
        fetch(`${URL}/api/products/${productId}`, {
          method: "DELETE",
          headers: {
            "X-Empresa-Id": user?.empresa_id
          }
        })
      )
    )
      .then(() => {
        onDelete();
      })
      .catch((error) => console.error("Error deleting products:", error));
  };

  return (
    <DeleteProductButton
      selectedCount={selectedProducts.length}
      onClick={handleDelete}
    />
  );
}
